namespace SolovisGateway.Admin.EnvironmentPools {

    /**
     * AdminPoolControl presents the user interface for administrating a single environment pool.
     */
    export class AdminPoolControl extends Solovis.UI.BaseControl {

        private _envPoolId;
        private _poolName;

        private _toolbarContainer;
        private _poolTable;

        constructor(options) {
            super(options);

            this._envPoolId = options.envPoolId;
        }

        public doRender() {            
            let poolDiv = $("<div>").css("width", "650px").appendTo(this.container);

            this._toolbarContainer = $("<div>").appendTo(poolDiv);
            this._poolTable = $("<table>").appendTo(poolDiv).addClass("table table-striped");

            $("<h3>").text("Other Actions").appendTo(this.container);

            let cycleScanDiv = $("<div>").appendTo(this.container);
            let cycleScanLink = $("<a>")
                .text("Scan For Investment Cycles Within Environment Pool")
                .appendTo(cycleScanDiv)
                .click(() => {
                    this._scanForInvestmentCyclesAsync();
                });

            this._setupToolbar();
            this._refreshTable();
        }

        private _setupToolbar() {
            var self = this;

            let toolbar = new Solovis.UI.Toolbar({
                container: this._toolbarContainer
            });

            toolbar.addItem({
                name: "editEnvironmentPoolButton",
                createToolbarItem: function () {
                    var editDataEnvironmentButton = new Solovis.UI.Buttons.Button({
                        element: $("<div>").text("Edit").prepend($("<span>").css("padding-right", "5px").addClass("fa fa-pencil")),
                        size: "small",
                        click: function () {
                            self._showEditEnvironmentPoolInterface({
                                environmentPoolId: self._envPoolId,
                                saveCallback: () => {
                                    self._refreshTable();
                                }
                            });
                        }
                    });

                    return editDataEnvironmentButton;
                }
            });

            toolbar.addItem({
                name: "reportsAndDbButtonGroup",
                createToolbarItem: function () {
                    var btnGroupContainerDiv = $("<div>").css("margin-left", "10px");

                    var btnGroup = new Solovis.UI.Buttons.ButtonGroup({
                        container: btnGroupContainerDiv
                    });

                    btnGroup.addButton({
                        name: "registerReportsButton",
                        buttonOptions: {
                            text: "Register Reports",
                            size: "small",
                            click: function () {
                                self._registerSystemReportsInAllDataEnvironments();
                            },
                            tooltipOptions: {
                                text: "Register System Reports In All Data Environments"
                            }
                        }
                    });

                    var dataEnvironmentsLink = $("<a>")
                        .addClass("btn btn-primary btn-xs")
                        .text("Database Versions")
                        .attr("href", Solovis.resolveUrl("~/Admin/EnvironmentPoolAdmin/DataEnvironmentVersions?poolId=" + self._envPoolId))
                        
                        .appendTo(btnGroupContainerDiv);

                    (dataEnvironmentsLink as any).solovisTooltip({
                        text: "Data Environment Versions"
                    });


                    btnGroup.addButton({
                        name: "refreshDnsButton",
                        buttonOptions: {
                            text: "Refresh DNS Mappings",
                            size: "small",
                            click: function () {
                                self._tryRefreshDataEnvironmentDnsMappings();
                            },
                            tooltipOptions: {
                                text: "Attempt to refresh DNS mappings for all data environments."
                            }
                        }
                    });


                    (btnGroupContainerDiv as any).getElement = function () {
                        return btnGroupContainerDiv;
                    }

                    return btnGroupContainerDiv;
                }
            });

            toolbar.addItem({
                name: "moreActionsDropdown",
                alignment: "right",
                createToolbarItem: function () {
                    var moreActionsDropDown = new Solovis.UI.Buttons.DropdownButton(
                        {
                            text: "More Actions",
                            size: "small",
                            links: [
                                {
                                    label: "Erase Environment Pool",
                                    click: function () {
                                        self._erasePool();
                                    }
                                }
                            ],
                            offsetRight: true,
                            fromRightEdge: true
                        });

                    return moreActionsDropDown;
                }
            });
        }

        private _showEditEnvironmentPoolInterface(options) {
            SolovisGateway.Admin.EnvironmentPools.EnvironmentPoolEditorDialog.showDialog(options);
        };

        private async _scanForInvestmentCyclesAsync() {
            if (!this._poolName) {
                return;
            }
            
            let response = await Solovis.Rpc.invokeAndWait(
                "~/Rpc/DataEnv/ScanForInvestmentCycles",
                {
                    forEnvironmentPoolName: this._poolName
                }
            );
                
            var result = response.result;
            console.log(result);

            var message = "See console for full details. Environments with cycles: ";
            message += result.envWithCycleCount;

            if (result.envWithErrorCount != 0) {
                message += ". Some environments had errors.";
            }

            Solovis.UI.alert(message);
        }

        private _refreshTable() {
            var self = this;
            Solovis.Rpc.invoke("~/Admin/EnvironmentPoolAdmin/GetEnvironmentPoolInfo",
                { id: this._envPoolId },
                function (response, success) {
                    if (success) {
                        let environmentPoolInfo = response.result.environmentPoolInfo;
                        self._poolName = environmentPoolInfo.name;

                        self._buildEnvironmentPoolInfoTable(environmentPoolInfo);
                    }
                    else {
                        $("#environmentPoolInfoTableBody")
                            .append(
                                $("<tr>")
                                    .append(
                                        $("<td>")
                                            .attr("colspan", "4")
                                            .text(response.error.message)
                                    )
                            );
                    }
                    var dataEnvInfoTable = $("#environmentPoolInfoTable");
                    if (dataEnvInfoTable && !dataEnvInfoTable.is(":visible")) {
                        dataEnvInfoTable.show();
                    }
                });
        }

        private _buildEnvironmentPoolInfoTable(environmentPoolInfo) {
            this._poolTable.html("");

            var tbody = $("<tbody>").appendTo(this._poolTable);
            if (tbody) {
                tbody.html("");
                var nameRow = $("<tr>").appendTo(tbody);
                $("<td>").css("vertical-align", "middle")
                    .append($("<strong>").text("Name"))
                    .appendTo(nameRow);
                $("<td>").css("vertical-align", "middle")
                    .text(environmentPoolInfo.name)
                    .appendTo(nameRow);

                var cloudServiceDomainRow = $("<tr>").appendTo(tbody);
                $("<td>").css("vertical-align", "middle")
                    .append($("<strong>").text("Cloud Service Domain"))
                    .appendTo(cloudServiceDomainRow);
                $("<td>").css("vertical-align", "middle")
                    .text(environmentPoolInfo.cloudServiceDomain ? environmentPoolInfo.cloudServiceDomain : "")
                    .appendTo(cloudServiceDomainRow);
            }
        }

        private _registerSystemReportsInAllDataEnvironments() {
            var self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Admin/EnvironmentPoolAdmin/RegisterSystemReportsInAllDataEnvironments",
                { id: self._envPoolId },
                function (response, success) {
                    if (success) {
                        Solovis.UI.alert("System reports registered.");
                    }
                });
        }

        private _tryRefreshDataEnvironmentDnsMappings () {
            var self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Admin/EnvironmentPoolAdmin/TryRefreshDataEnvironmentDnsMappings",
                { id: self._envPoolId },
                function (response, success) {
                    if (success) {
                        Solovis.UI.alert("DNS refresh attempt completed. You must independently verify if this worked.");
                    }
                });
        }

        private _erasePool() {
            var self = this;
            Solovis.UI.confirm("Erase environment pool?", "Erase Environment Pool",
                function (confirmed) {
                    if (confirmed) {
                        Solovis.Rpc.invokeAndWait(
                            "~/Admin/EnvironmentPoolAdmin/ErasePool",
                            { poolId: self._envPoolId },
                            function (response, success) {
                                if (success) {
                                    self.container.html("Environment pool has been deleted.");
                                }
                            });
                    }
                });
        }
    }
}